import Axios from "../../utils/axios";

//Get Country data
export const getRoles = (payload) => {
    const URL = "/getCMSRoles";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};

export const saveCMSUser = (payload) => {
    const URL = "/saveCMSUser";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};

export const getCMSUser = (payload) => {
    const URL = "/user/read";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};

export const updateCMSUser = (payload) => {
    const URL = "/user/update";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};

export const deleteCMSUser = (payload) => {
    const URL = "/user/inactivate";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};

export const setAdminUserPassword = (payload) => {
    const URL = "/admin/user/password/set";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};

export const resyncUserAuth0Profile = (payload) => {
    const URL = "/admin/user/auth0/resync";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};

export const lookupCMSUserByEmail = (payload) => {
    const URL = "/admin/user/auth0/lookup";
    return Axios.post(URL, payload).then((res) => {
        return res.data;
    });
};
export const getAvailableUsers = async () => {
    const response = await Axios.post("/availableusers", {});
        return response.data;
  };
  export const saveUserCircleAPI = async (data) => {
      const payload = {
        userAuthId: data.userAuthId,
        circlerequeststatus: data.circlerequeststatus,
      };

      if (data.rejectionnotes) {
        payload.rejectionnotes = data.rejectionnotes;
      }

      const response = await Axios.post("/usercircles/save", payload);
      return response.data;
    };

    export const getMyCircleRequestsAPI = async (payload = {}) => {
      const response = await Axios.post("/usercircles/mycirclerequests", payload);
      return response.data;
    };
    export const updateUserCircleAPI = async (data) => {
      const payload = {
        _id: data._id,
        userAuthId: data.userAuthId,
        circlerequeststatus: data.circlerequeststatus,
      };

      if (data.rejectionnotes) {
        payload.rejectionnotes = data.rejectionnotes;
      }

      const response = await Axios.post("/usercircles/update", payload);
      return response.data;
    };
    // AvailableUsersAPI.js

  export const getMyCircleAPI = async (payload = {}) => {
      const response = await Axios.post("/usercircles/mycircle", payload);
      return response.data;
    };
    // Add this API function to UsersAPI.js
export const getChurchUsersAPI = async (payload) => {
  const response = await Axios.post("/churchusers", payload);
  return response.data;
};
// Add this API function to UsersAPI.js
export const getNotificationsAPI = async (payload) => {
  const response = await Axios.post("/notification/list", payload);
  return response.data;
};

// Add this API function to UsersAPI.js
export const sendNotificationToOneAPI = async (payload) => {
  const formData = new URLSearchParams();

  // Required fields
  formData.append('userAuthId', payload.userAuthId);
  formData.append('notification_title', payload.notification_title);
  formData.append('notification_description', payload.notification_description);
  formData.append('churchObjId', payload.churchObjId);

  // Optional fields
  if (payload.channelObjId) {
    formData.append('channelObjId', payload.channelObjId);
  }

  if (payload.ministriesObjId) {
    formData.append('ministriesObjId', payload.ministriesObjId);
  }

  const response = await Axios.post("/notification/sendtoone", formData.toString(), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return response.data;
};
